import React, { useEffect, useState } from "react"
import "./quick-access-menu.scss"
import { graphql, useStaticQuery } from "gatsby"
import imgHombre from '../../../assets/images/img-hombre.svg'
import imgPadre from '../../../assets/images/img-padre.svg'
import imgMadre from '../../../assets/images/img-madre.svg'
import useMobile from "../../../hooks/useMobile"
import transversalServices from '../../../services/transversal-services'
import useHomeLinkMode from '../../../hooks/useHomeLinkMode';
import { sessionStorage, localStorage } from '../../../utils/storage'
import useHaveClubPeque from '../../../hooks/useHaveClubPeque'


const QuickAccessMenu = ({ setActiveShoppingModal }) => {

    const { homeLink } = useHomeLinkMode();
    const {haveClubPeque} = useHaveClubPeque()
    
    const resultQuery = useStaticQuery(
        graphql`
            query{
                allContentfulPequeninTransversal {
                        nodes {
                            node_locale
                            redireccionChat
                            redireccionPremios
                            menu {
                                opcionesDelMenu {
                                    nombreDeLaOpcion
                                    redireccionDeLaOpcion
                                }
                            }
                        }
                    }
            }


        `
    )

    const [logged, setLogged] = useState(false);
    const [userData, setUserData] = useState(null);
    const [showModal, setShowModal] = useState(false)
    const contentInfo = resultQuery.allContentfulPequeninTransversal.nodes.filter(e => e.node_locale === process.env.LOCALE)[0]

    useEffect(() => {
        if (document.getElementsByClassName("helpButton").length > 0) {
            const element = document.getElementsByClassName("helpButton")
            element[0].style.visibility = showModal ? "visible" : "hidden"
        }
    }, [showModal])
    
    const mobile = useMobile()

    useEffect(() => {
        const tokenInfo = localStorage.getItem('TOKEN_INFO') ? localStorage.getItem('TOKEN_INFO') : null
        if (tokenInfo && (window.innerWidth < 1024)) {
            setLogged(true)
            let config = {
                headers: {
                    Authorization: tokenInfo.idToken,
                },
            }

            transversalServices.getInfoUser(config).then(
                response => {
                    if (response.status === 200) {
                        setUserData({
                            image: getRolImage(response.data.rolesName[0] ? response.data.rolesName[0] : ""),
                            name: response.data.name.split(" ", 1)[0]
                        });
                    }
                }
            )
        }
    }, []);

    const getRolImage = (rol) => {
        let image
        switch (rol) {
            case "Mamá":
                image = imgMadre
                break;

            case "Papá":
                image = imgPadre
                break;

            default:
                image = imgHombre
                break;

        }
        return image
    }

    return (
        <div className="f-a-quick-access-container">

            {mobile && <div className="f-a-quick-access__mobile-background" />}
            {mobile ?
                <a
                    className={"f-a-quick-access-icon"}
                    href={homeLink}>

                    <span className="icon icon-ico-home" />
                    <p className="f-a-quick-access-label">Inicio</p>
                </a>
                :
                ""
            }
            <a
                className={"f-a-quick-access-icon"}
                onClick={() => { setActiveShoppingModal(true) }}>
                {mobile ? <span className="icon icon-ico-shopping-cart" />: <span className="icon-desktop f-a-quick-access-icon__shopping-cart" />}
                <p className="f-a-quick-access-label">Compra</p>
            </a>
            
               {/*  <a
                    className={"f-a-quick-access-icon " + ((logged && userData) ? "__active" : "")}
                    onClick={() => sessionStorage.setItem('PREVIOUS_PAGE', window.location.href)}
                    href={(logged && userData) ? (homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "mi-perfil/")) : (homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "autenticacion"))}
                >
                    {(logged && userData) ?
                        <div
                            className="f-a-quick-access__session-image"
                            onClick={() => { location.href = homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "mi-perfil/") }}
                        >
                            <img
                                src={userData ? userData.image : ""}
                                alt="user image"
                                loading="lazy"
                            />
                        </div>
                        :
                        <div className="f-a-quick-access-session-container">
                            <span className="icon icon-ico-user" />
                        </div>
                    }
                    <p className="f-a-quick-access-label f-a-quick-access-session-label">
                        {(logged && userData) ? (userData ? userData.name : "") : "Ingresar"}
                    </p>
                </a>
                :
                ""
             */}
            {
                haveClubPeque &&
                <a className="f-a-quick-access-icon" href={homeLink + "club-pequenin/catalogo-de-beneficios/"}>
                <span className="icon icon-ico-club" />
                <p className="f-a-quick-access-label">
                    {mobile ?
                        "Club"
                        :
                        "Beneficios"
                    }
                </p>
            </a>}
            <div className="f-a-quick-access-icon"
                onClick={() => {
                        setShowModal(!showModal)
                }}
            >
                {mobile ? <span className="icon icon-ico-chat" />: <span className="icon-desktop f-a-quick-access-icon__chat" />}
                <p className="f-a-quick-access-label">Chat</p>
            </div>
           { mobile &&
            <a className="f-a-quick-access-icon" href={homeLink + "productos/"}>
                <span className="icon icon-ico-diaper" />
                <p className="f-a-quick-access-label">
                    Productos
                </p>
            </a>}
            {!mobile && <a
                className={"f-a-quick-access-icon"}
                href="https://api.whatsapp.com/send?phone=573233357619" target="_blank">
                <span className=" icon-desktop f-a-quick-access-icon__whatsapp" />
                <p className="f-a-quick-access-label">WHATSAPP</p>
            </a>}
        </div>
    )
}

export default QuickAccessMenu;